import { tryCatchHelper } from '../../../helpers';
import {
  ACTIVO_BLOQUES_PEDAGOGICOS,
  ALL_BLOQUES_PEDAGOGICOS,
  LOADING_ALL_BLOQUES_PEDAGOGICOS,
} from './BloquesPedagogicosReducer';
import {
  allBloquesPedagogicosService,
  deleteBloquesPedagogicosService,
  oneBloquesPedagogicosService,
  saveBloquesPedagogicosService,
} from './BloquesPedagogicosService';

export const allBloquesPedagogicosAction = async (dispatch, params) => {
  try {
    dispatch({ type: LOADING_ALL_BLOQUES_PEDAGOGICOS, payload: true });
    const res = await allBloquesPedagogicosService(params);
    dispatch({ type: ALL_BLOQUES_PEDAGOGICOS, payload: res.data });
    dispatch({ type: LOADING_ALL_BLOQUES_PEDAGOGICOS, payload: false });
    return res.data;
  } catch (e) {
    dispatch({ type: LOADING_ALL_BLOQUES_PEDAGOGICOS, payload: false });
    tryCatchHelper(e);
    return false;
  }
};

export const saveBloquesPedagogicosAction = async (
  { dispatch, notify },
  id,
  data,
  params,
) => {
  try {
    const res = await saveBloquesPedagogicosService(id, data);
    notify(res.data.message);
    await allBloquesPedagogicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoBloquesPedagogicosAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_BLOQUES_PEDAGOGICOS, payload: data });
};

export const oneBloquesPedagogicosAction = async (dispatch, id) => {
  try {
    const res = await oneBloquesPedagogicosService(id);
    await setActivoBloquesPedagogicosAction(dispatch, res.data.data);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};

export const deleteBloquesPedagogicosAction = async (
  { dispatch, notify },
  id,
  params,
) => {
  try {
    const res = await deleteBloquesPedagogicosService(id);
    notify(res.data.message);
    await setActivoBloquesPedagogicosAction(dispatch, null);
    await allBloquesPedagogicosAction(dispatch, params);
    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};
